import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHead } from "@/components/site/PageHeader";
import { Stagger, Item } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

export const GalleryTile = ({ item, className, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={`gallery-tile-${item.id}`}
    className={cn("group relative block h-full w-full overflow-hidden border border-white/10 bg-surface text-left", className)}
  >
    <img src={item.image} alt={item.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1100ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]" />
    <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-obsidian/10 to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-100" />
    <div className="absolute inset-x-0 bottom-0 translate-y-2 p-5 opacity-0 transition-[transform,opacity] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-crimson">{item.category}</p>
      <p className="mt-1 font-display text-base font-semibold">{item.title}</p>
    </div>
  </button>
);

export const GalleryPreview = ({ items = [], number = "03" }) => {
  const shown = items.slice(0, 5);
  if (!shown.length) return null;
  return (
    <section data-testid="gallery-preview" className="border-t border-white/10 py-24 sm:py-32">
      <div className="wrap">
        <SectionHead
          number={number}
          eyebrow="Gallery"
          lines={["Inside the", "showroom."]}
          right={<Link to="/gallery" data-testid="gallery-view-all-link" className="btn-ghost">View gallery <ArrowUpRight className="h-4 w-4" /></Link>}
        />
        <Stagger className="grid grid-cols-2 gap-3 auto-rows-[180px] sm:auto-rows-[220px] md:grid-cols-4 md:auto-rows-[240px]" gap={0.08}>
          {shown.map((item, i) => (
            <Item key={item.id} className={cn(i === 0 && "col-span-2 row-span-2")}>
              <Link to="/gallery" className="block h-full"><GalleryTile item={item} /></Link>
            </Item>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
